import { render, staticRenderFns } from "./ReceptionHeadTr.vue?vue&type=template&id=0846ef20&"
import script from "./ReceptionHeadTr.vue?vue&type=script&lang=js&"
export * from "./ReceptionHeadTr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports